import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthService } from "../service/auth.service";
import { TokenStorageService } from "../service/token-storage.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const token = this.tokenStorage.getToken();

    //  If no token → go to login
    if (!token) {
      this.router.navigate(["/authentication/signin"]);
      return false;
    }

    //  If token expired → logout and go to login
    if (this.authService.isTokenExpired()) {
      this.tokenStorage.signOut();
      this.router.navigate(["/authentication/signin"]);
      return false;
    }

    // ✅ Role check (if route has role restrictions)
    const user = this.tokenStorage.getUser();
    const userRole = user?.role;

    if (route.data?.role && route.data.role.indexOf(userRole) === -1) {
      this.router.navigate(["/authentication/signin"]);
      return false;
    }

    // ✅ Allow navigation
    return true;
  }
}
